import { useEffect, useState } from "react";

/**
 * Recording mode — DRY / MONITOR / PRINT.
 *
 * - **DRY**:   Mic recorded raw, FX applied only during playback.
 * - **MON**:   Hear yourself wet through the FX rack while singing; the SAVED
 *              buffer stays dry so you can re-sweeten later.
 * - **PRINT**: Same as MON, but the FX get baked INTO the saved buffer (destructive).
 *              Single-slot undo via `engine._undoCache`.
 *
 * Returns the mode + setter. Side-effect: pushes the value into the engine
 * every time it changes (engine.setRecordingMode handles the routing-graph
 * reconfiguration) AND persists to localStorage.
 */
export default function useRecordingMode(engine) {
  const [recordingMode, setRecordingMode] = useState(() => {
    try { return localStorage.getItem("elpm-rec-mode") || "dry"; } catch { return "dry"; }
  });

  useEffect(() => {
    engine.setRecordingMode(recordingMode);
    try { localStorage.setItem("elpm-rec-mode", recordingMode); } catch (e) { void e; }
  }, [engine, recordingMode]);

  return [recordingMode, setRecordingMode];
}
